function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  className: "opacity",
  opacity: 0.4,
  d: "M11.7404 0H4.26667C1.54311 0 0 1.54311 0 4.26667V11.7333C0 14.4569 1.54311 16 4.26667 16H11.7404C14.464 16 16 14.4569 16 11.7333V4.26667C16 1.54311 14.464 0 11.7404 0Z",
  fill: "#C4C4C4"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "white",
  d: "M4.295 5.89526C3.93233 5.89526 3.63367 6.19393 3.63367 6.56371V12.0606C3.63367 12.4233 3.93233 12.7219 4.295 12.7219C4.66478 12.7219 4.96344 12.4233 4.96344 12.0606V6.56371C4.96344 6.19393 4.66478 5.89526 4.295 5.89526Z",
  fill: "#C4C4C4"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "white",
  d: "M8.02828 3.27124C7.66561 3.27124 7.36694 3.56991 7.36694 3.93968V12.0606C7.36694 12.4232 7.66561 12.7219 8.02828 12.7219C8.39805 12.7219 8.69672 12.4232 8.69672 12.0606V3.93968C8.69672 3.56991 8.39805 3.27124 8.02828 3.27124Z",
  fill: "#C4C4C4"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "white",
  d: "M11.7119 8.79651C11.3421 8.79651 11.0435 9.09518 11.0435 9.46495V12.0605C11.0435 12.4232 11.3421 12.7218 11.7048 12.7218C12.0746 12.7218 12.3732 12.4232 12.3732 12.0605V9.46495C12.3732 9.09518 12.0746 8.79651 11.7119 8.79651Z",
  fill: "#C4C4C4"
});

function SvgChartIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref, _ref2, _ref3, _ref4);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartIcon);
export default __webpack_public_path__ + "static/media/chartIcon.eb4a5b0b.svg";
export { ForwardRef as ReactComponent };